<div class="w-1/2 mt-8 flex bg-gradient-to-t from-headerfr to-headerto" style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; transform: translateX(50%);">
    <div class="p-12 text-center justify-center items-center text-yellow-200">
        <h4 class="text-xl font-bold text-white text-center" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);">
            What is a Living Lab?
        </h4>
        <p class="text-md font-light text-white text-center mt-4" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);">
            A Living Lab is a space or community that is experimenting with multi-stakeholder projects or
            initiatives aimed at radically transforming current systems and structures as we know them. In FUSILLI,
            Living Labs are spaces where stakeholders experiment with radical changes to the local urban food
            system. In our project, employees of municipalities coordinated the Living Labs in their city.
        </p>
    </div>
</div>
<div class="grid grid-cols-3 mt-24">
    <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
    class="mt-4 px-8 py-1   text-colortext text-2xl font-light cursor-pointer hover:bg-headerto hover:text-yellow-200 place-self-center" (click)="goToRunning()">
        <div class="text">
            Transformation journeys
        </div>
    </button>
    <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
    class="mt-4 px-8 py-1   text-colortext text-2xl font-light cursor-pointer hover:bg-headerto hover:text-yellow-200 place-self-center" (click)="goToLabCities()">
        <div class="text">
            FUSILLI cities information
        </div>
    </button>
    <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
    class="mt-4 px-8 py-1   text-colortext text-2xl font-light cursor-pointer hover:bg-headerto hover:text-yellow-200 place-self-center" (click)="goToFusilliProject()">
        <div class="text">
            FUSILLI Project results
        </div>
    </button>
</div>